import ClientPassengerInterface from '../../interfaces/client/Passenger'

export const PASSENGERS_FETCHED = 'PASSENGERS_FETCHED'

export default (passengers: ClientPassengerInterface[]) => ({
  type: PASSENGERS_FETCHED,
  passengers,
})
